import api from './api';

export interface Group {
  _id?: string;
  name: string;
  parentGroup?: string;
  isAIGenerated?: boolean;
  needsApproval?: boolean;
  approved?: boolean;
  createdAt?: string;
  createdBy?: string;
  approvedBy?: string;
  approvedAt?: string;
}

export interface GroupsResponse {
  success: boolean;
  data: Group[];
  count: number;
}

export const groupService = {
  async getGroups(): Promise<GroupsResponse> {
    const response = await api.get<GroupsResponse>('/api/groups');
    return response.data;
  },

  async getParentGroups(): Promise<GroupsResponse> {
    const response = await api.get<GroupsResponse>('/api/parent-groups');
    return response.data;
  },

  async approveGroup(groupId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/api/groups/approve/${groupId}`);
    return response.data;
  },

  async rejectGroup(groupId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/api/groups/reject/${groupId}`);
    return response.data;
  },
};

